import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation, fadeOutOnLeaveAnimation, fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {CoachingService} from '../service/coaching.service';
import {TeamService} from '../../team/service/team.service';
import {CoachingRoleModel, CoachingSummaryModel} from '../model/coaching-summary.model';
import {DelegateSimpleModel} from '../../team/models/delegate.model';
import {EventsService} from '../../../services/events.service';
import {Subscription} from 'rxjs';
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from '../../../services/user.service';


@Component({
    selector: 'app-coaching-team',
    templateUrl: './coaching-team.component.html',
    styleUrls: ['./coaching-team.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})

export class CoachingTeamComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    roles: CoachingRoleModel[] = [];
    managers: DelegateSimpleModel[] = [];

    coachingList: CoachingSummaryModel[] = null;
    coachingListValid = false;
    coachingListPromise: Promise<CoachingSummaryModel[]> = null;

    roleId = 0;
    managerId = 0;

    constructor(
        private analytics: AnalyticsService,
        private router: Router,
        private event: EventsService,
        public userService: UserService,
        private coachingService: CoachingService,
        private teamService: TeamService
    ) {
        this.subscriptions.push(
            this.event.subscribe('coaching:saveCoachingForm', () => this.coachingListValid = false)
        );
    }

    ngOnInit() {
        this.coachingService.getCoachingRolesList()
            .then(roles => {
                this.roles = roles;
            });
        this.teamService.getMyManagersList()
            .then(managers => {
                this.managers = managers;
            });
    }

    ionViewWillEnter() {
        if (this.coachingList === null || !this.coachingListValid) {
            this.coachingListPromise = this.coachingService.getTeamCoachingList();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Team Coaching');

        if (this.coachingList === null || !this.coachingListValid) {
            this.coachingListPromise.then(coachingList => {
                this.coachingList = coachingList;
                this.coachingListValid = true;
            });
        }
    }

    openCoachingReport(coachingId: number, delegateId: number) {
        this.router.navigate(['/coaching/user/' + String(delegateId) + '/report/', coachingId]);
    }

    openCoachingComments(delegateId: number) {
        this.router.navigate(['/coaching/user/comments/', delegateId]);
    }

    newCoachingReport(delegateId: number) {
        this.router.navigate(['/coaching/user/form/new/', delegateId]);
    }

    selectFilter() {
        this.coachingList = null;
        this.coachingService.getTeamCoachingList(this.managerId, this.roleId)
            .then(coachingList => {
                this.coachingList = coachingList;
                this.coachingListValid = true;
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
